/** Texts for Je account: two-step verification, password, devices. */
export const accountNl = {
  'help.button': 'Hulp',
  'help.title': 'Hulp',
  'help.search': 'Zoek in de hulp',
  'help.here': 'Over deze pagina',
  'help.all': 'Alle artikelen',
  'help.back': 'Alle hulp',
  'help.none': 'Niets gevonden. Probeer een ander woord.',
  'help.more': 'Kom je er niet uit? Mail ons op {email}.',
  'help.openPage': 'Open als pagina',
  'help.publicTitle': 'Hulp bij KoalaSpot',
  'help.publicIntro': 'Korte uitleg over alles in KoalaSpot: de agenda, online boeken, je team en je account.',
  'help.toApp': 'Naar de app',
  'help.toc': 'Op deze pagina',
  'legal.title': 'Juridisch',
  'legal.terms': 'Voorwaarden',
  'legal.dpa': 'Verwerkersovereenkomst',
  'legal.privacy': 'Privacy',
  'legal.subprocessors': 'Subverwerkers',
  'legal.readDpa': 'Lees de volledige verwerkersovereenkomst',
  'legal.draft': 'Concept. Deze tekst wordt nog door een jurist nagekeken.',
  'legal.missing': 'nog in te vullen: {key}',
  'legal.dutchOnly': 'Deze tekst is alleen in het Nederlands beschikbaar.',
  'help.related': 'Ook handig',
  'help.prev': 'Vorige',
  'help.next': 'Volgende',
  'help.count': '{n} artikelen',
  'help.notFound': 'Dit artikel bestaat niet (meer).',
  'help.cat.start': 'Aan de slag',
  'help.cat.agenda': 'Agenda',
  'help.cat.klanten': 'Klanten en berichten',
  'help.cat.online': 'Online boeken',
  'help.cat.team': 'Team en locaties',
  'help.cat.account': 'Account en privacy',
  'acc.title': 'Je account',
  'acc.intro': 'Hoe je inlogt. Dit geldt alleen voor jou, niet voor je collega’s.',
  'acc.hubHint2fa': 'Tweestapsverificatie staat uit',
  'acc.hubHint2faOn': 'Tweestapsverificatie staat aan',
  'tf.title': 'Tweestapsverificatie',
  'tf.intro': 'Naast je wachtwoord vul je een code in uit een app op je telefoon. Zo kan niemand met alleen je wachtwoord bij je agenda en klanten.',
  'tf.on': 'Staat aan. Je logt in met je wachtwoord en een code uit je app.',
  'tf.off': 'Staat uit.',
  'tf.start': 'Zet aan',
  'tf.password': 'Je wachtwoord',
  'tf.passwordWhy': 'Ter controle dat jij het bent.',
  'tf.continue': 'Verder',
  'tf.step1': '1. Installeer een authenticator-app, bijvoorbeeld Google Authenticator of Microsoft Authenticator.',
  'tf.step2': '2. Scan deze QR-code met de app.',
  'tf.manual': 'Lukt scannen niet? Vul deze sleutel in de app in:',
  'tf.step3': '3. Vul de code van 6 cijfers in die de app nu laat zien.',
  'tf.code': 'Code uit de app',
  'tf.confirm': 'Bevestigen',
  'tf.backupTitle': 'Bewaar je herstelcodes',
  'tf.backupIntro': 'Kwijt of nieuwe telefoon? Met een herstelcode kom je toch binnen. Elke code werkt één keer. Bewaar ze ergens veilig, bijvoorbeeld in je wachtwoordmanager of geprint.',
  'tf.copy': 'Kopieer',
  'tf.copied': 'Gekopieerd',
  'tf.download': 'Download',
  'tf.done': 'Ik heb ze bewaard',
  'tf.newCodes': 'Nieuwe herstelcodes',
  'tf.newCodesHint': 'De oude codes werken dan niet meer.',
  'tf.disable': 'Zet uit',
  'tf.disableWhy': 'Vul je wachtwoord in om tweestapsverificatie uit te zetten.',
  'tf.requiredOwner': 'Je salon is geen proefaccount meer. Zet tweestapsverificatie aan om je salon te blijven beheren. Het kost twee minuten.',
  'tf.requiredAdmin': 'Het beheer kan elke salon openen. Zet daarom eerst tweestapsverificatie aan.',
  'tf.requiredOff': 'Eigenaren van een betaalde salon moeten tweestapsverificatie aan laten staan.',
  'tf.requiredTeam': 'Voor het KoalaSpot-team blijft tweestapsverificatie altijd aan.',
  'login.codeTitle': 'Vul je code in',
  'login.codeIntro': 'Open je authenticator-app en vul de code van 6 cijfers in.',
  'login.backupIntro': 'Vul een van je herstelcodes in. Elke code werkt één keer.',
  'login.backupCode': 'Herstelcode',
  'login.trust': 'Onthoud dit apparaat 30 dagen',
  'login.useBackup': 'Telefoon niet bij de hand? Gebruik een herstelcode',
  'login.useApp': 'Gebruik de code uit je app',
  'pw.title': 'Wachtwoord',
  'pw.current': 'Huidige wachtwoord',
  'pw.new': 'Nieuw wachtwoord',
  'pw.change': 'Wachtwoord wijzigen',
  'pw.changed': 'Gewijzigd. Op je andere apparaten ben je uitgelogd.',
  'dev.title': 'Waar je bent ingelogd',
  'push.title': 'Meldingen op dit apparaat',
  'push.intro': 'Een melding bij een nieuwe online afspraak, en als een klant online annuleert of verzet. Medewerkers krijgen alleen meldingen over hun eigen afspraken.',
  'push.on': 'Aan op dit apparaat.',
  'push.enable': 'Zet meldingen aan',
  'push.disable': 'Zet uit',
  'push.blocked': 'Meldingen zijn geblokkeerd voor KoalaSpot in je browser. Sta ze toe in de instellingen van je browser of telefoon en probeer het opnieuw.',
  'push.unsupported': 'Deze browser ondersteunt geen meldingen. Probeer Chrome, Edge, Firefox of Safari.',
  'push.homeScreen': 'Op iPhone en iPad werken meldingen als KoalaSpot op je beginscherm staat: tik op Deel → "Zet op beginscherm", open KoalaSpot daarvandaan en zet ze hier aan.',
  'push.confirmTitle': 'Meldingen staan aan',
  'push.confirmBody': 'Je hoort het hier als er online geboekt, geannuleerd of verzet wordt.',
  'dev.intro': 'Herken je iets niet? Log overal anders uit en kies een nieuw wachtwoord.',
  'dev.this': 'Dit apparaat',
  'dev.active': 'Laatst actief {when}',
  'dev.signOut': 'Uitloggen',
  'dev.signOutOthers': 'Overal anders uitloggen',
  'dev.unknown': 'Onbekend apparaat',
  'authErr.INVALID_EMAIL_OR_PASSWORD': 'E-mailadres of wachtwoord klopt niet.',
  'authErr.INVALID_PASSWORD': 'Dat wachtwoord klopt niet.',
  'authErr.PASSWORD_TOO_SHORT': 'Kies een wachtwoord van minstens 10 tekens.',
  'authErr.USER_ALREADY_EXISTS': 'Er is al een account met dit e-mailadres. Log in of vraag een nieuw wachtwoord aan.',
  'authErr.INVALID_CODE': 'Die code klopt niet. Let op: de code verandert elke 30 seconden.',
  'authErr.INVALID_BACKUP_CODE': 'Die herstelcode klopt niet of is al gebruikt.',
  'authErr.TOO_MANY_ATTEMPTS': 'Te vaak geprobeerd. Log opnieuw in.',
  'authErr.ACCOUNT_TEMPORARILY_LOCKED': 'Te vaak een verkeerde code. Probeer het over 15 minuten opnieuw.',
  'authErr.INVALID_TWO_FACTOR_COOKIE': 'Dat duurde te lang. Log opnieuw in.',
  'authErr.SESSION_NOT_FRESH': 'Log voor de zekerheid opnieuw in en probeer het dan nog eens.',
  'authErr.INVALID_TOKEN': 'Deze link werkt niet meer. Vraag een nieuwe aan.',
  'authErr.TOO_MANY_REQUESTS': 'Even te veel pogingen. Wacht een minuut en probeer het opnieuw.',
  'sub.intro': 'Eén abonnement met alles erin. Je betaalt per agenda: iedereen in je team die je online kunt boeken.',
  'sub.trial': 'Je proefperiode loopt tot en met {date}',
  'sub.trialLeft': 'Nog {n} dagen gratis. Je eerste betaling volgt zodra je je abonnement start.',
  'sub.comped': 'Gratis account',
  'sub.compedBody': 'Voor deze salon hoef je niets te betalen.',
  'sub.active': 'Je abonnement loopt',
  'sub.activeBody': '{agendas} · {interval}. Volgende afschrijving: {date}.',
  'sub.pastDue': 'Je laatste betaling is niet gelukt',
  'sub.pastDueBody': 'Je hebt een betaallink per e-mail gekregen. Betaal vóór {date}, anders kun je daarna alleen nog kijken en neemt je boekingspagina geen afspraken meer aan.',
  'sub.suspended': 'Je abonnement staat stil',
  'sub.suspendedBody': 'Je kunt alles nog bekijken, maar niets wijzigen, en je boekingspagina neemt geen afspraken aan. Betaal de openstaande factuur om verder te gaan.',
  'sub.cancelled': 'Je abonnement is opgezegd',
  'sub.cancelledBody': 'Alles werkt nog tot en met {date}. Daarna sluit je boekingspagina.',
  'sub.expired': 'Je proefperiode of abonnement is afgelopen',
  'sub.expiredBody': 'Je boekingspagina neemt geen afspraken meer aan. Start je abonnement en alles werkt meteen weer. Je gegevens blijven tot 90 dagen na het einde bewaard.',
  'sub.choose': 'Kies hoe je betaalt',
  'sub.monthly': 'Per maand',
  'sub.yearly': 'Per jaar',
  'sub.yearlyNote': '2 maanden gratis',
  'sub.perMonth': 'per maand',
  'sub.perYear': 'per jaar',
  'sub.agendas': '{n} agenda\'s',
  'sub.agendaOne': '1 agenda',
  'sub.exclVat': 'excl. btw ({incl} incl. btw)',
  'sub.howPrice': 'Eén agenda kost € 19 per maand. Vanaf twee agenda\'s betaal je € 10 per agenda. Komt er iemand bij, dan past je abonnement zich aan vanaf de volgende afschrijving.',
  'sub.start': 'Abonnement starten',
  'sub.starting': 'Even geduld…',
  'sub.payNote': 'Je rondt de betaling af op de beveiligde betaalpagina van onze betaalpartner Plug&Pay. Opzeggen kan altijd, tegen het einde van je betaalde periode.',
  'sub.ownerOnly': 'Alleen de eigenaar van de salon kan het abonnement starten of wijzigen.',
  'sub.unavailable': 'Een abonnement afsluiten kan hier binnenkort. Je proefperiode loopt gewoon door.',
  'sub.paidBanner': 'Bedankt! We verwerken je betaling. Het kan een minuut duren voordat je abonnement hier staat.',
  'sub.thanks': 'Bedankt!',
  'sub.thanksBody': 'We verwerken je betaling en sturen je zo terug naar je abonnement.',
  'sub.interval.month': 'maandelijks',
  'sub.interval.year': 'jaarlijks',
  'team.priceNote': 'Elke collega in de agenda is een agenda in je abonnement. Met deze collega erbij betaal je {to} {per} in plaats van {from} (excl. btw), vanaf je volgende afschrijving.',
  'sub.cancel': 'Abonnement opzeggen',
  'sub.cancelConfirm': 'Weet je het zeker? Alles werkt nog tot het einde van je betaalde periode. Daarna sluit je boekingspagina; je gegevens kun je downloaden bij Privacy en gegevens.',
  'sub.cancelYes': 'Ja, zeg op',
  'sub.cancelNo': 'Nee, ik blijf',
  'sub.resume': 'Toch doorgaan',
  'sub.invoices': 'Facturen',
  'sub.invoicesBody': 'Je krijgt elke factuur per e-mail van onze betaalpartner Plug&Pay, op het e-mailadres waarmee je betaalt. Andere bankrekening of factuurgegevens? Mail ons, dan regelen we het.',
  'banner.trialEnds': 'Je proefperiode loopt over {n} dagen af.',
  'banner.trialEndsOne': 'Je proefperiode loopt morgen af.',
  'banner.pastDue': 'Je laatste betaling is niet gelukt. Betaal op tijd, dan blijft alles werken.',
  'banner.suspended': 'Je abonnement staat stil: je kunt alles bekijken, maar niets wijzigen. Je boekingspagina neemt geen afspraken aan.',
  'banner.action': 'Naar je abonnement',
  'trial.cta.title': 'Start je gratis proefperiode',
  'trial.cta.subtitle': '14 dagen gratis, daarna één abonnement met alles erin.',
  'trial.cta.p1': 'Je vult je gegevens en je rekeningnummer (IBAN) in bij onze betaalpartner Plug&Pay.',
  'trial.cta.p2': 'Je betaalt niets tijdens de proefperiode. Daarna schrijven we automatisch je eerste maand af, tenzij je opzegt.',
  'trial.cta.p3': 'Opzeggen kan altijd, ook tijdens de proefperiode, in KoalaSpot.',
  'trial.cta.button': 'Gratis proberen',
  'trial.cta.note': 'Heb je al een account? Log in via de link hierboven.',
  'trial.done.title': 'Je proefperiode is gestart',
  'trial.done.subtitle': 'Check je e-mail.',
  'trial.done.body': 'Binnen een paar minuten krijg je een e-mail met een link om je wachtwoord te kiezen en je salon in te richten. Zie je niets? Kijk ook in je spam.',
};

export const accountEn: Record<keyof typeof accountNl, string> = {
  'help.button': 'Help',
  'help.title': 'Help',
  'help.search': 'Search help',
  'help.here': 'About this page',
  'help.all': 'All articles',
  'help.back': 'All help',
  'help.none': 'Nothing found. Try another word.',
  'help.more': 'Still stuck? Email us at {email}.',
  'help.openPage': 'Open as page',
  'help.publicTitle': 'KoalaSpot help',
  'help.publicIntro': 'Short guides to everything in KoalaSpot: the calendar, online booking, your team and your account.',
  'help.toApp': 'Go to the app',
  'legal.title': 'Legal',
  'legal.terms': 'Terms',
  'legal.dpa': 'Processing agreement',
  'legal.privacy': 'Privacy',
  'legal.subprocessors': 'Sub-processors',
  'legal.readDpa': 'Read the full processing agreement',
  'legal.draft': 'Draft. This text is still being reviewed by a lawyer.',
  'legal.missing': 'to be filled in: {key}',
  'legal.dutchOnly': 'This text is only available in Dutch.',
  'help.toc': 'On this page',
  'help.related': 'Also useful',
  'help.prev': 'Previous',
  'help.next': 'Next',
  'help.count': '{n} articles',
  'help.notFound': 'This article doesn’t exist (any more).',
  'help.cat.start': 'Getting started',
  'help.cat.agenda': 'Calendar',
  'help.cat.klanten': 'Clients and messages',
  'help.cat.online': 'Online booking',
  'help.cat.team': 'Team and locations',
  'help.cat.account': 'Account and privacy',
  'acc.title': 'Your account',
  'acc.intro': 'How you log in. This is just for you, not for your colleagues.',
  'acc.hubHint2fa': 'Two-step verification is off',
  'acc.hubHint2faOn': 'Two-step verification is on',
  'tf.title': 'Two-step verification',
  'tf.intro': 'Besides your password you enter a code from an app on your phone. That way nobody gets into your calendar and clients with just your password.',
  'tf.on': 'On. You log in with your password and a code from your app.',
  'tf.off': 'Off.',
  'tf.start': 'Switch on',
  'tf.password': 'Your password',
  'tf.passwordWhy': 'To check it’s you.',
  'tf.continue': 'Continue',
  'tf.step1': '1. Install an authenticator app, for example Google Authenticator or Microsoft Authenticator.',
  'tf.step2': '2. Scan this QR code with the app.',
  'tf.manual': 'Can’t scan? Enter this key in the app:',
  'tf.step3': '3. Enter the 6-digit code the app shows now.',
  'tf.code': 'Code from the app',
  'tf.confirm': 'Confirm',
  'tf.backupTitle': 'Keep your backup codes',
  'tf.backupIntro': 'Lost or new phone? A backup code still gets you in. Each code works once. Keep them somewhere safe, such as your password manager or on paper.',
  'tf.copy': 'Copy',
  'tf.copied': 'Copied',
  'tf.download': 'Download',
  'tf.done': 'I’ve saved them',
  'tf.newCodes': 'New backup codes',
  'tf.newCodesHint': 'The old codes stop working.',
  'tf.disable': 'Switch off',
  'tf.disableWhy': 'Enter your password to switch off two-step verification.',
  'tf.requiredOwner': 'Your salon is no longer on a trial. Switch on two-step verification to keep managing your salon. It takes two minutes.',
  'tf.requiredAdmin': 'The back office can open any salon, so switch on two-step verification first.',
  'tf.requiredOff': 'Owners of a paid salon must keep two-step verification on.',
  'tf.requiredTeam': 'For the KoalaSpot team, two-step verification always stays on.',
  'login.codeTitle': 'Enter your code',
  'login.codeIntro': 'Open your authenticator app and enter the 6-digit code.',
  'login.backupIntro': 'Enter one of your backup codes. Each code works once.',
  'login.backupCode': 'Backup code',
  'login.trust': 'Remember this device for 30 days',
  'login.useBackup': 'Phone not at hand? Use a backup code',
  'login.useApp': 'Use the code from your app',
  'pw.title': 'Password',
  'pw.current': 'Current password',
  'pw.new': 'New password',
  'pw.change': 'Change password',
  'pw.changed': 'Changed. You were logged out on your other devices.',
  'dev.title': 'Where you’re logged in',
  'push.title': 'Notifications on this device',
  'push.intro': 'A notification for a new online booking, and when a client cancels or reschedules online. Team members only get notifications about their own appointments.',
  'push.on': 'On for this device.',
  'push.enable': 'Turn on notifications',
  'push.disable': 'Turn off',
  'push.blocked': 'Notifications are blocked for KoalaSpot in your browser. Allow them in your browser or phone settings and try again.',
  'push.unsupported': 'This browser doesn’t support notifications. Try Chrome, Edge, Firefox or Safari.',
  'push.homeScreen': 'On iPhone and iPad, notifications work when KoalaSpot is on your home screen: tap Share → "Add to Home Screen", open KoalaSpot from there and turn them on here.',
  'push.confirmTitle': 'Notifications are on',
  'push.confirmBody': 'You’ll hear here when someone books, cancels or reschedules online.',
  'dev.intro': 'Don’t recognise something? Log out everywhere else and choose a new password.',
  'dev.this': 'This device',
  'dev.active': 'Last active {when}',
  'dev.signOut': 'Log out',
  'dev.signOutOthers': 'Log out everywhere else',
  'dev.unknown': 'Unknown device',
  'authErr.INVALID_EMAIL_OR_PASSWORD': 'Email address or password is incorrect.',
  'authErr.INVALID_PASSWORD': 'That password is incorrect.',
  'authErr.PASSWORD_TOO_SHORT': 'Choose a password of at least 10 characters.',
  'authErr.USER_ALREADY_EXISTS': 'There is already an account with this email address. Log in or ask for a new password.',
  'authErr.INVALID_CODE': 'That code is incorrect. Note: the code changes every 30 seconds.',
  'authErr.INVALID_BACKUP_CODE': 'That backup code is incorrect or already used.',
  'authErr.TOO_MANY_ATTEMPTS': 'Too many tries. Log in again.',
  'authErr.ACCOUNT_TEMPORARILY_LOCKED': 'Too many wrong codes. Try again in 15 minutes.',
  'authErr.INVALID_TWO_FACTOR_COOKIE': 'That took too long. Log in again.',
  'authErr.SESSION_NOT_FRESH': 'Log in again to be safe, then try once more.',
  'authErr.INVALID_TOKEN': 'This link no longer works. Ask for a new one.',
  'authErr.TOO_MANY_REQUESTS': 'A few too many tries. Wait a minute and try again.',
  'sub.intro': 'One subscription with everything included. You pay per agenda: everyone on your team clients can book online.',
  'sub.trial': 'Your trial runs until {date}',
  'sub.trialLeft': '{n} days free left. Your first payment follows when you start your subscription.',
  'sub.comped': 'Free account',
  'sub.compedBody': "You don't pay anything for this salon.",
  'sub.active': 'Your subscription is running',
  'sub.activeBody': '{agendas} · {interval}. Next payment: {date}.',
  'sub.pastDue': "Your last payment didn't go through",
  'sub.pastDueBody': 'You received a payment link by email. Pay before {date}; after that you can only view, and your booking page stops taking appointments.',
  'sub.suspended': 'Your subscription is on hold',
  'sub.suspendedBody': "You can still view everything but not change it, and your booking page doesn't take appointments. Pay the open invoice to continue.",
  'sub.cancelled': 'Your subscription is cancelled',
  'sub.cancelledBody': 'Everything keeps working until {date}. After that your booking page closes.',
  'sub.expired': 'Your trial or subscription has ended',
  'sub.expiredBody': 'Your booking page no longer takes appointments. Start your subscription and everything works again straight away. Your data is kept for up to 90 days after the end.',
  'sub.choose': 'Choose how you pay',
  'sub.monthly': 'Monthly',
  'sub.yearly': 'Yearly',
  'sub.yearlyNote': '2 months free',
  'sub.perMonth': 'per month',
  'sub.perYear': 'per year',
  'sub.agendas': '{n} agendas',
  'sub.agendaOne': '1 agenda',
  'sub.exclVat': 'excl. VAT ({incl} incl. VAT)',
  'sub.howPrice': 'One agenda costs €19 per month. From two agendas you pay €10 per agenda. When someone joins, your subscription follows from the next payment.',
  'sub.start': 'Start subscription',
  'sub.starting': 'One moment…',
  'sub.payNote': 'You finish paying on the secure payment page of our payment partner Plug&Pay. You can cancel any time, as of the end of your paid period.',
  'sub.ownerOnly': 'Only the salon owner can start or change the subscription.',
  'sub.unavailable': 'You can take out a subscription here soon. Your trial simply continues.',
  'sub.paidBanner': 'Thank you! We are processing your payment. It can take a minute before your subscription shows here.',
  'sub.thanks': 'Thank you!',
  'sub.thanksBody': "We're processing your payment and will take you back to your subscription.",
  'sub.interval.month': 'monthly',
  'sub.interval.year': 'yearly',
  'team.priceNote': 'Everyone in the calendar is an agenda in your subscription. With this team member you pay {to} {per} instead of {from} (excl. VAT), from your next payment.',
  'sub.cancel': 'Cancel subscription',
  'sub.cancelConfirm': 'Are you sure? Everything keeps working until the end of your paid period. After that your booking page closes; you can download your data under Privacy and data.',
  'sub.cancelYes': 'Yes, cancel',
  'sub.cancelNo': "No, I'll stay",
  'sub.resume': 'Keep my subscription',
  'sub.invoices': 'Invoices',
  'sub.invoicesBody': 'You receive every invoice by email from our payment partner Plug&Pay, at the address you pay with. Different bank account or invoice details? Email us and we will sort it out.',
  'banner.trialEnds': 'Your trial ends in {n} days.',
  'banner.trialEndsOne': 'Your trial ends tomorrow.',
  'banner.pastDue': "Your last payment didn't go through. Pay in time and everything keeps working.",
  'banner.suspended': "Your subscription is on hold: you can view everything but not change it. Your booking page doesn't take appointments.",
  'banner.action': 'Go to your subscription',
  'trial.cta.title': 'Start your free trial',
  'trial.cta.subtitle': '14 days free, then one subscription with everything included.',
  'trial.cta.p1': 'You enter your details and your bank account (IBAN) with our payment partner Plug&Pay.',
  'trial.cta.p2': "You pay nothing during the trial. After that we automatically take your first month, unless you cancel.",
  'trial.cta.p3': 'You can cancel any time, also during the trial, in KoalaSpot.',
  'trial.cta.button': 'Try for free',
  'trial.cta.note': 'Already have an account? Log in via the link above.',
  'trial.done.title': 'Your trial has started',
  'trial.done.subtitle': 'Check your email.',
  'trial.done.body': "Within a few minutes you'll get an email with a link to choose your password and set up your salon. Don't see it? Check your spam too.",
};
